export default `\
import React from 'react';
import styled, { keyframes } from 'styled-components';

const RotatingCard = ({
  width,
  height,
  src,
  alt,
}) => (
  <div style={{ perspective: 1000 }}>
    <Wrapper
      style={{
        // This property's new ↓
        transformStyle: 'preserve-3d',
      }}
    >
      {/* Our image being rotated */}
      <img
        alt={alt}
        src={src}
        style={{
          width,
          height,
          display: 'block',
        }}
      />

      {/* Our backface */}
      <div
        style={{
          // This property is also new ↓
          backfaceVisibility: 'hidden',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor:
            'hsla(0, 100%, 100%, 0.9)',
        }}
      />
    </Wrapper>
  </div>
);

////////////////////////////////////
/* Relevant bits above this line */
//////////////////////////////////

// I'm using "styled-components" to do the CSS
// rotation animation. This is how you specify
// a CSS keyframes animation.
const rotationKeyframes = keyframes\`
  from {
    transform: rotateY(0deg);
  }

  to {
    transform: rotateY(360deg);
  }
\`

const Wrapper = styled.div\`
  position: relative;
  display: inline-block;

  /*
    We'll only enable the animation for folks
    who have NOT ticked the “prefers-reduced-
    motion” checkbox
  */
  @media (prefers-reduced-motion: no-preference) {
    animation:
      \${rotationKeyframes}
      4000ms
      linear
      infinite;
  }
\`

export default function App() {
  return (
    <RotatingCard
      width={210}
      height={280}
      alt="A neon city at night"
      src="/img/city.jpg"
    />
  );
}
`;
